import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/logo-light.svg'


const _hoisted_1 = { id: "sidebar" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "list-unstyled" }
const _hoisted_5 = { class: "list-unstyled" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "list-unstyled" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "list-unstyled" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "list-unstyled" }

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useUserStore } from '@/store/user';
import { useUploadsStore } from '@/store/uploads';
import { BTooltip } from 'bootstrap-vue-next';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  emits: ['toggle'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const userStore = useUserStore();
const uploadsStore = useUploadsStore();

const sidebarToggled = ref(false);
const subMenuOpen = ref({
  analytics: true,
  admin: true,
  devTools: true,
  settings: true,
});

const route = useRoute();

// Track window width
const screenWidth = ref<number>(window.innerWidth);

function updateWidth() {
  screenWidth.value = window.innerWidth;
}

// Listen for resize events
onMounted(() => {
  window.addEventListener('resize', updateWidth);
});
onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});

// If screen is > 700px, "default visible" => hidden if sidebarToggled is true
// If screen is <= 700px, "default hidden" => hidden if sidebarToggled is false
const isMobile = computed<boolean>(() => {
  return screenWidth.value <= 700;
});

const isSidebarHidden = computed<boolean>(() => {
  if (!isMobile.value) {
    // Desktop: default visible => hidden if sidebarToggled is true
    return sidebarToggled.value === true;
  } else {
    // Mobile: default hidden => hidden if sidebarToggled is false
    return sidebarToggled.value === false;
  }
});

// close the sidebar on every route change (mobile only)
watch(
  () => route.fullPath, // runs after any navigation
  () => {
    if (isMobile.value && !isSidebarHidden.value) {
      toggleSidebar();
    }
  }
);

// keep visual state when the breakpoint is crossed ---------------
watch(isMobile, (nowMobile, wasMobile) => {
  // sidebar was hidden on large screen -> going to mobile
  if (nowMobile && !wasMobile && sidebarToggled.value) {
    toggleSidebar(); // toggle back to keep hidden sidebar on mobile
  }
});

// --- sidebar handlers ---
function toggleSidebar() {
  sidebarToggled.value = !sidebarToggled.value;
  emits('toggle', sidebarToggled.value);
}

function toggleSubMenu(menu: 'analytics' | 'settings' | 'admin' | 'devTools') {
  subMenuOpen.value[menu] = !subMenuOpen.value[menu];
}

function logout() {
  userStore.logout();
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      id: "sideToggle",
      class: _normalizeClass({ 'sidebar-visibility-toggled': sidebarToggled.value })
    }, [
      _createElementVNode("button", {
        type: "button",
        id: "btnSidebarToggle",
        onClick: toggleSidebar
      }, [
        (isSidebarHidden.value)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: ['fas', 'bars']
            }))
          : _createCommentVNode("", true),
        (!isSidebarHidden.value)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: ['fas', 'bars']
            }))
          : _createCommentVNode("", true),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Toggle Menu", -1))
      ])
    ], 2),
    _createElementVNode("div", {
      id: "sideColumn",
      class: _normalizeClass([{ 'sidebar-visibility-toggled': sidebarToggled.value }, "p-4"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'Dashboard' },
          style: {"text-decoration":"none"},
          class: "p-0 m-0"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("img", {
              src: _imports_0,
              class: "logo",
              alt: "Sampling Human"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'PersonalInformation' },
          class: "user"
        }, {
          default: _withCtx(() => [
            _createElementVNode("small", null, [
              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'user'] }),
              _createTextVNode(" " + _toDisplayString(_unref(userStore).email), 1)
            ])
          ]),
          _: 1
        }),
        _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'Dashboard' } }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'home'] }),
                _cache[7] || (_cache[7] = _createTextVNode(" Dashboard", -1))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleSubMenu('analytics')), ["prevent"])),
              class: "dropdown-toggle"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'line-chart'] }),
              _cache[8] || (_cache[8] = _createTextVNode(" Analytics ", -1))
            ]),
            _withDirectives(_createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'Projects' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'list'] }),
                    _cache[9] || (_cache[9] = _createTextVNode(" Projects", -1))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'DataManager' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'database'] }),
                    _cache[10] || (_cache[10] = _createTextVNode(" Data Manager", -1))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'UploadManager' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'upload'] }),
                    _cache[12] || (_cache[12] = _createTextVNode(" Upload Manager ", -1)),
                    (_unref(uploadsStore).hasStaleUploads)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createVNode(_component_font_awesome_icon, {
                            id: "warning-stale-uploads",
                            icon: ['fas', 'triangle-exclamation'],
                            class: "fa-beat",
                            style: {"color":"#ffc107"}
                          }),
                          _createVNode(_unref(BTooltip), { target: "warning-stale-uploads" }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode(" Some uploads seem to be in a stale state. See the upload manager for details. Ignore this if your uploads are actively managed by another instance of the app running in another tab or on another device. ", -1)
                            ]))]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, subMenuOpen.value.analytics]
            ])
          ]),
          (_unref(userStore).admin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toggleSubMenu('admin')), ["prevent"])),
                  class: "dropdown-toggle"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'layer-group'] }),
                  _cache[13] || (_cache[13] = _createTextVNode(" Admin ", -1))
                ]),
                _withDirectives(_createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'AdminCodesList' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'ticket'] }),
                        _cache[14] || (_cache[14] = _createTextVNode(" Kits and Coupons", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'AdminOrganizationList' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'users'] }),
                        _cache[15] || (_cache[15] = _createTextVNode(" Organizations", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'AdminUserList' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user'] }),
                        _cache[16] || (_cache[16] = _createTextVNode(" Users", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'AdminInvitesList' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'envelope'] }),
                        _cache[17] || (_cache[17] = _createTextVNode(" Invites", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'SystemDataManager' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'database'] }),
                        _cache[18] || (_cache[18] = _createTextVNode(" System Data", -1))
                      ]),
                      _: 1
                    })
                  ])
                ], 512), [
                  [_vShow, subMenuOpen.value.admin]
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(userStore).developer)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (toggleSubMenu('devTools')), ["prevent"])),
                  class: "dropdown-toggle"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'code'] }),
                  _cache[19] || (_cache[19] = _createTextVNode(" Dev Tools ", -1))
                ]),
                _withDirectives(_createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'AdminComputeTasks' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'list-check'] }),
                        _cache[20] || (_cache[20] = _createTextVNode(" Compute Tasks", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  (_unref(userStore).developer)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                        _createVNode(_component_router_link, { to: { name: 'AdminStats' } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'chart-simple'] }),
                            _cache[21] || (_cache[21] = _createTextVNode(" Stats", -1))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'AdminLogs' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'file-lines'] }),
                        _cache[22] || (_cache[22] = _createTextVNode(" Logs ", -1))
                      ]),
                      _: 1
                    })
                  ])
                ], 512), [
                  [_vShow, subMenuOpen.value.devTools]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (toggleSubMenu('settings')), ["prevent"])),
              class: "dropdown-toggle"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'gears'] }),
              _cache[23] || (_cache[23] = _createTextVNode(" Settings ", -1))
            ]),
            _withDirectives(_createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'PersonalInformation' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user'] }),
                    _cache[24] || (_cache[24] = _createTextVNode(" Personal information", -1))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'OrganizationSettings' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'users'] }),
                    _cache[25] || (_cache[25] = _createTextVNode(" Organization settings", -1))
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, subMenuOpen.value.settings]
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers(logout, ["prevent"])
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sign-out'] }),
              _cache[26] || (_cache[26] = _createTextVNode(" Sign Out ", -1))
            ])
          ])
        ])
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "footer" }, [
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: "https://www.samplinghuman.com",
            target: "_blank",
            class: "p-0 m-0"
          }, " © Sampling Human, Inc. ")
        ])
      ], -1))
    ], 2)
  ]))
}
}

})